import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import style from './ActiveTradePlanModule.module.css';
import ChartTab from './components/chartTab/ChartTab';
import { useWebsocketStore } from '../../../../stores/websocketStore/websocketProvider';
import { observer } from 'mobx-react-lite';
import { InPositionTopRow } from './components/topRows/InPositionTopRow';
import { NotInPositionTopRow } from './components/topRows/NotInPositionTopRow';
import { useTabs } from './components/detailsSection/detailsUtils/useTabs';
import { colors } from '../../../../colorVars';

const ActiveTradePlanModule = observer(({ tradePlanId }) => {
  const { tradePlanStore } = useWebsocketStore();
  const inPosition = tradePlanStore.tradePlans[tradePlanId]?.inPosition ?? null;
  const expanded = tradePlanStore.tradePlans[tradePlanId]?.expanded;
  const instrument = tradePlanStore.tradePlans[tradePlanId]?.instrument;
  const tabProps = useTabs(instrument);
  const clearTabs = tabProps.clearUnusedTabsUponEntry;
  const clearAllTabs = tabProps.clearTabsOnRestart;

  useEffect(() => {
    if (inPosition){
      clearTabs();
    } else {
      clearAllTabs();
    }
  }, [inPosition]);

  if (inPosition === null) {
    return null;
  }

  return (
    <div
      className={style.container}
      style={{ borderColor: inPosition ? colors.green : colors.lightGrey }}
    >
      {inPosition ? (
        <InPositionTopRow
          tradePlanId={tradePlanId}

        />
      ) : (
        <NotInPositionTopRow
          tradePlanId={tradePlanId}

        />
      )}

      {expanded && (
        <div>
          <ChartTab tradePlanId={tradePlanId} tabProps={tabProps} />
        </div>
      )}
    </div>
  );
});

ActiveTradePlanModule.propTypes = {
  tradePlanId: PropTypes.any,
};

export default ActiveTradePlanModule;
